import { Pipe, PipeTransform } from '@angular/core';
import { GalleryStatus } from '@picflow/types';

export const getGalleryStatusIcon = (status: GalleryStatus, small = false): string => {
  if (status === 'approved') return 'check-circle';
  if (status === 'no_status') return small ? 'circle-dotted-small' : 'circle-dotted';
  if (status === 'progress') return 'clock-outline';
  if (status === 'review') return 'circle-double';
  if (status === 'revisions') return 'cross-revert';
};

@Pipe({
  name: 'galleryStatusIcon',
  standalone: true,
})
export class GalleryStatusIconPipe implements PipeTransform {
  transform(status: GalleryStatus, small = false): string {
    return getGalleryStatusIcon(status, small);
  }
}
